(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/country-dropdown.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/country-dropdown.js');
"use strict";


const _svs$ui$ReactForm = svs.ui.ReactForm,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option,
  ControlGroup = _svs$ui$ReactForm.ControlGroup,
  FormContext = _svs$ui$ReactForm.FormContext;
const COUNTRYID = svs.ticket_partner.sharedComponents.input.constants.names.COUNTRYID;
const countries = svs.ticket_partner.sharedComponents.input.constants.countries;
const CountryDropdown = _ref => {
  let handleDropDownChange = _ref.handleDropDownChange,
    state = _ref.state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  const validate = val => {
    let errorMessage = '';
    let isValid;
    if (!val) {
      isValid = false;
      errorMessage = 'Du måste välja ett land';
    } else {
      isValid = true;
    }
    return {
      errorMessage,
      isValid,
      name
    };
  };
  return React.createElement(FormContext.Consumer, null, _ref2 => {
    var _state$COUNTRYID, _state$COUNTRYID2;
    let register = _ref2.register;
    return React.createElement(ControlGroup, {
      isLessSpace: isLessSpace,
      v2: true
    }, React.createElement(Select, {
      disabled: disabled,
      id: COUNTRYID,
      name: name || COUNTRYID,
      onChange: handleDropDownChange,
      v2: true,
      value: ((_state$COUNTRYID = state[COUNTRYID]) === null || _state$COUNTRYID === void 0 ? void 0 : _state$COUNTRYID.toString()) || ''
    }, countries.map(_ref3 => {
      let name = _ref3.name,
        id = _ref3.id;
      return React.createElement(Option, {
        key: id,
        value: id.toString()
      }, name);
    })), React.createElement("input", {
      hidden: true,
      readOnly: true,
      ref: register(name, validate),
      value: ((_state$COUNTRYID2 = state[COUNTRYID]) === null || _state$COUNTRYID2 === void 0 ? void 0 : _state$COUNTRYID2.toString()) || ''
    }));
  });
};
svs.ticket_partner.sharedComponents.input.CountryDropdown = CountryDropdown;

 })(window);